// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"518":"Medidas","968":"Selector"}[chunkId] + "." + {"518":"65abab28","968":"323cf4fd"}[chunkId] + ".js";
};